var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPregnant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27433 2.42639C1.31261 12.1815 2.24225 22.129 5.01304 31.5209C5.21189 32.1949 5.60261 32.8015 6.1411 33.2438C11.7427 37.8453 18.7902 40.7266 25.526 43.3899C25.8698 43.5259 26.2016 43.6965 26.4823 43.94C27.3464 44.6894 30.0917 45.7784 31.0746 45.8982",
    stroke: "#8E8F97",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36718 1.53955C2.33444 1.83498 2.30366 2.13085 2.27441 2.42673",
    stroke: "#8E8F97",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7291 5.09009C12.735 12.2837 12.6948 19.2363 11.8662 26.3805C15.4874 27.2877 18.3102 30.4141 21.1851 32.8283L26.7579 37.5077C27.2802 36.6307 28.6172 36.19 29.6217 36.0938C30.6262 35.9975 31.6309 36.2242 32.6121 36.4619C33.2584 36.6185 33.9143 36.7853 34.4851 37.1311",
    stroke: "#8E8F97",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2842 43.6945L32.6058 44.2804",
    stroke: "#8E8F97",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.498 41.6902L34.5167 42.7158",
    stroke: "#8E8F97",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1582 39.3689L36.0899 40.7119",
    stroke: "#8E8F97",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5073 1.53955C21.1347 2.05899 21.7583 2.58309 22.381 3.10675C23.9954 4.46501 25.6427 5.86697 26.683 7.71584C27.9759 10.0138 28.1867 12.9096 27.2405 15.3757C26.351 17.6941 23.4944 19.0524 21.0471 19.1398",
    stroke: "#8E8F97",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4033 15.5955C32.2515 17.0513 36.3083 20.991 37.9589 25.8463C39.2378 29.6082 39.0462 33.8435 37.5322 37.5076",
    stroke: "#8E8F97",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20891 37.7163C4.94596 41.5281 4.03881 45.3651 4.00781 49.4472",
    stroke: "#8E8F97",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3286 49.447C29.3461 48.3115 29.5294 46.5992 29.381 45.4104",
    stroke: "#8E8F97",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.562 29.9293H49.0544",
    stroke: "#8E8F97",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5811 18.7631L45.0506 16.2539",
    stroke: "#8E8F97",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5806 41.0947L45.0501 43.6039",
    stroke: "#8E8F97",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPregnant);
export default __webpack_public_path__ + "static/media/pregnant.2892f31e1ac21b621e0629c8f7362a0d.svg";
export { ForwardRef as ReactComponent };